import React, { Component } from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'

export default class Dna extends Component {
    constructor(props){
        super(props)
        this.state = {
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        
        return (
            <div className="row" id="body">
                    
            <div className="col-12 mx-0 col-lg-10" id="content">

                <div className="row pt-4" id="ux_design">
                    <div className="col-12 px-0" id="ow">
                      <p className="h4">Overview</p>
                      <p className="pt-1">
                      Now a day many people wants to know about  their family 
heritage. For that we gonna design a <strong>DNA</strong> app. People can create a 
family tree on this app. People can post their day to day life 
memories and their family events as well. Family members can 
create a joint family by simply share the unique link. This app will be 
very useful to know about their family to the future generation no 
matter how many years have passed.
                      </p>
                    </div>
                    <div className="col-12 px-0 pt-4" id="po">
                      <div className="row mx-0">
                        <div className="col-sm-4 text-center">
                          <p className="h5">Project Name</p>
                          <p>DNA</p>
                        </div>
                        <div className="col-sm-4 text-center">
                          <p className="h5">Project duration</p>
                          <p>1 Week</p>
                        </div>
                        <div className="col-sm-4 text-center">
                          <p className="h5">My role</p>
                          <p>Ui designer</p>
                        </div>
                      </div>
                    </div>
                </div>

                <div className="row pt-4" id="ui_design">
                    <div className="col-12 px-0">
                      <img width="100%" id="sp" src={require('../../../Images/Ui_design/dna/Site Map.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="we" src={require('../../../Images/Ui_design/dna/WireFrame.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="cr" src={require('../../../Images/Ui_design/dna/Color.png')} alt="Case_studies_2" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="ty" src={require('../../../Images/Ui_design/dna/Typography.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="iy" src={require('../../../Images/Ui_design/dna/Iconography.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="ct" src={require('../../../Images/Ui_design/dna/Component.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" src={require('../../../Images/Ui_design/dna/Component1.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" src={require('../../../Images/Ui_design/dna/Component2.png')} alt="Case_studies_1" />
                    </div>
                    <div className="col-12 px-0 pt-4">
                      <img width="100%" id="he" src={require('../../../Images/Ui_design/dna/Prototype.png')} alt="Case_studies_1" />
                    </div>

                </div> 
            
            </div>
                    
            <div className="col-lg-2 d-none px-5 d-lg-block pt-4 h-25 sticky-top" id="sidebar" style={{top: "56px"}}>

                <p className="h4">CONTENT</p>
                <p>
                  <AnchorLink href="#ow" className="bullet">Overview</AnchorLink>
                  <br />
                  <AnchorLink href="#po" className="bullet">Project info</AnchorLink>
                  <br />
                  <AnchorLink href="#sp" className="bullet">Site map</AnchorLink>
                  <br />
                  <AnchorLink href="#we" className="bullet">Wire frame</AnchorLink>
                  <br />
                  <AnchorLink href="#cr" className="bullet">Color</AnchorLink>
                  <br />
                  <AnchorLink href="#ty" className="bullet">Typography</AnchorLink>
                  <br />
                  <AnchorLink href="#iy" className="bullet">Iconograhpy</AnchorLink>
                  <br />
                  <AnchorLink href="#ct" className="bullet">Component</AnchorLink>
                  <br />
                  <AnchorLink href="#he" className="bullet">HI-FI Prototype</AnchorLink>
                </p>
                
              <div className="row pt-4 px-3">
                <p className="h4">TOOLS</p>

                <div className="col-12 px-2">
                  <div className="row">
                          <img width="25%" className="tools" src={require('../../../Images/Tools/xd.png')} alt="Case_studies_1" />
                          <img width="25%" className="tools" src={require('../../../Images/Tools/ps.png')} alt="Case_studies_1" />
                  </div>
                </div>
                
              </div>

            </div>
                  
            </div>
    )
}
}